import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import BaseButton from "../../components/UI/BaseButton/BaseButton";
import { Box } from "@mui/material";

function CreditScore() {
  const navigate = useNavigate();

  const goBack = () => {
    navigate("/settings");
  };

  return (
    <Box className="page-container">
      <Box className="header-container">
        <Box className={`page-title`}>Credit Scoring</Box>
        <Box>
          A comprehensive tool for managing customer data, processing loan applications, and overseeing loan repayments
        </Box>
      </Box>

      <Box className="settings-center-container" sx={{mb: 3}}>
        <CreditScoreComponent />
        <Box className="return-button">
          <BaseButton
            buttonText={"Return to Admin Center"}
            onClick={goBack}
          />
        </Box>
      </Box>
    </Box>
  );
}

const CreditScoreComponent = () => {
  const [iframeSrc, setIframeSrc] = useState("");

  const getPhp = async () => {
    try {
      setIframeSrc("https://dev2.4pay.ca/lab/creditscore2/");
    } catch (error) {
      console.error("Error fetching the HTML", error);
    }
  };

  useEffect(() => {
    getPhp();
  }, []);

  return (
    <Box
      sx={{
        width: "100%",
        height: "110vh",
        borderRadius: 2,
        overflow: "hidden",
        boxShadow: 3,
      }}
    >
      {iframeSrc && (
        <iframe
          src={iframeSrc}
          width="100%"
          height="100%"
          style={{ border: "none" }}
          allowFullScreen
          title="Credit Scoring Page"
        />
      )}
    </Box>
  );
};

export default CreditScore;
